import React, { FC } from 'react'
import WebTracker, { TrackerConfig } from '@core/web-tracker'
import { TrackerProviderProps } from './types'

export const trackerContext = React.createContext<WebTracker | null>(null)

export const createTracker = (config: TrackerConfig): WebTracker => new WebTracker(config)
export const TrackerProvider: FC<TrackerProviderProps> = (props) => {
  const {tracker, children} = props
  return <trackerContext.Provider value={tracker}>{children}</trackerContext.Provider>
}
export const useTracker = (): WebTracker => {
  const tracker = React.useContext(trackerContext)
  if (!tracker) {
    throw new Error('useTracker must be used within a TrackerProvider.')
  }
  return tracker
}